import { Navigate, Route, Routes as ModuleRoutes } from '@direct-frontend/modules-router';
import { RumWrapper } from '@adv-frontend/yastore-modules/lib';
import { CheckoutEditorAsync } from '#pages/checkoutEditor';
import { ConstructorAsync } from '#pages/constructor';
import { DashboardsAsync } from '#pages/dashboards';
import { EmailAuthAsync } from '#pages/emailAuth';
import { EmailConstructorAsync } from '#pages/emailConstructor';
import { NotFound } from '#pages/notFound';
import { NotificationsAsync } from '#pages/notifications';
import { PromotionAsync } from '#pages/promotion';
import { ErrorBoundaryRouterWrapper } from '#shared/components/ErrorBoundary';
import { RedirectWithSearchParams } from '#shared/components/RedirectWithSearchParams';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { pathToPageName } from '#shared/lib/dom';
import { isExperimentFlagEnabled } from '#shared/lib/flags';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import {
    checkoutEditorRoute,
    constructorRoute,
    dashboardsRoute,
    emailAuthRoute,
    emailConstructorRoute,
    notificationsRoute,
    promotionRoute,
} from '#shared/lib/routes';
import { ApplicationLayoutRoute } from '../ApplicationLayout';
import { DashboardLayout, getDefaultRootRoute } from '../DashboardLayout';
import { clientsRoutes } from './clientsRoutes';
import { contentRoutes } from './contentRoutes';
import { editorRoutes } from './editorRoutes';
import { newsRoutes } from './newsRoutes';
import { ordersRoutes } from './ordersRoutes';
import { promotionsRoutes } from './promotionsRoutes';
import { settingsRoutes } from './settingsRoutes';

export const Routes = () => {
    const { activeAuthMethod, authed, isInternalYandexUser } = getSafeUserRequestContext();

    return (
        <ModuleRoutes>
            <Route element={<RumWrapper pathToPageName={pathToPageName} />}>
                <Route element={<ErrorBoundaryRouterWrapper />}>
                    <Route
                        path={emailAuthRoute.route}
                        element={
                            activeAuthMethod === 'email' && !authed ? <EmailAuthAsync /> : <Navigate to="/" replace />
                        }
                    />
                    <Route element={<ApplicationLayoutRoute />}>
                        <Route element={<DashboardLayout />}>
                            <Route path="/" element={<RedirectWithSearchParams to={getDefaultRootRoute()} replace />} />
                            {/*
                             * Для опционального отображения роутов используется функция,
                             * а не HOC, потому что в Route можно вкладывать только Route компоненты
                             * https://reactrouter.com/6.30.3/utils/create-routes-from-elements
                             */}
                            {renderWithPermission(
                                'analytics',
                                'read',
                                <Route path={dashboardsRoute.route} element={<DashboardsAsync />} />
                            )}
                            {contentRoutes()}
                            {ordersRoutes()}
                            {clientsRoutes()}
                            {promotionsRoutes()}
                            {newsRoutes()}
                            {editorRoutes()}
                            {settingsRoutes(isInternalYandexUser)}
                            {renderWithPermission(
                                'store_promotion',
                                'read',
                                <Route path={promotionRoute.route} element={<PromotionAsync />} />
                            )}
                            <Route path={notificationsRoute.route} element={<NotificationsAsync />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Route>
                    {isExperimentFlagEnabled('enable_checkout_editor') &&
                        renderWithPermission(
                            'settings',
                            'read',
                            <Route path={checkoutEditorRoute.route} element={<CheckoutEditorAsync />} />
                        )}
                    {renderWithPermission(
                        'editor',
                        'read',
                        <Route path={constructorRoute.route} element={<ConstructorAsync />} />
                    )}
                    {isExperimentFlagEnabled('enable_email_constructor') &&
                        renderWithPermission(
                            'editor',
                            'read',
                            <Route path={emailConstructorRoute.route} element={<EmailConstructorAsync />} />
                        )}
                </Route>
            </Route>
        </ModuleRoutes>
    );
};
